import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateTablePayload } from '@app-store/slices/table/create'

interface TaskAction extends Action {
    payload: ICreateTablePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.table.create

function* createTableSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/meeting/table`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB) {
                payload.sagaCB?.onSuccess()
            }
            notification.success({
                message: 'Table created successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createTableSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createTableSagaTask)
}

export default createTableSaga
